import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { BrokerAuditDataModel } from '../../../model/brokerAuditDataModel';
import { BadQuestionnaireModel } from '../../../model/badQuestionnaireModel';
import { BadSectionModel } from '../../../model/badSectionModel';
import { MessageModel, ContentPageModel } from '../../../model/models';
import { SectionTextModel } from '../../../model/sectionTextModel';
import { BadAnswerModel } from '../../../model/badAnswerModel';
import { StorageService } from '../../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';


import { StringUtils } from '../../../shared/utils/stringUtils';



@Component({
  selector: 'app-broker-audit-declaration-receipt',
  templateUrl: './broker-audit-declaration-receipt.component.html',
  styleUrls: ['./broker-audit-declaration-receipt.component.css']
})
export class BrokerAuditDeclarationReceiptComponent implements OnInit, OnDestroy {

  completeFunctionResponse: CompleteFunctionResponseModel;
  completeFunctionSubscription: Subscription;
  notifyBrokerAuditReviewAffirmationsSubscription : Subscription;

  headerContent: SectionContentModel = new SectionContentModel;
  workflow: WorkflowModel = new WorkflowModel();
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();
  badQuestionnaireDataModel: BadQuestionnaireModel = new BadQuestionnaireModel();
  questionnaireSections: Array<BadSectionModel> = [];
  startFunction: StartFunctionResponseModel;
  startStepMessageContent : ContentPageModel;
  badAffirmation1 : boolean;
  badAffirmation2 : boolean;
  userMessages: Array<MessageModel> = [];
  public now: Date = new Date();

  constructor(private router: Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private startFunctionService: StartFunctionService,
    private currentPageWatcher: CurrentPageWatcherService,
    private completeFunctionService: CompleteFunctionService,
    private storageService : StorageService,
    private stringUtils: StringUtils) {

    //create header content message
    let textModel: SectionTextModel = new SectionTextModel();
    textModel.text = "You have successfully completed the Broker Audit Declaration. Please click the Return to Home button and click the Renew My Personal License link to start your license renewal.";
    this.headerContent.textList.push(textModel);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);

    this.completeFunctionSubscription = this.completeFunctionService.getNotifyCompleteFunctionResponse().subscribe(data => {
      this.completeFunctionResponse = data;
      
   
      console.log("Complete Function Response : " + this.completeFunctionResponse);
    });

    this.notifyBrokerAuditReviewAffirmationsSubscription = this.brokerAuditDeclarationService.getNotifyBrokerAuditReviewAffirmations().subscribe(affirmationList=>{
      this.badAffirmation1 = affirmationList[0];
      this.badAffirmation2 = affirmationList[1];
    })
  }
  


  ngOnInit() {
    this.startFunction = this.storageService.getStartFunctionData();
    console.log(JSON.stringify(this.startFunction.Workflow.Steps[0].StepMessage));

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    
    this.startStepMessageContent = this.startFunction.Workflow.Steps[0].StepMessage;
    //set startStepMessageContent.Sections[1].lists to display business information and business address
    this.startStepMessageContent.Sections[1].Lists[0].Title.StringContent="Business Information";
    this.startStepMessageContent.Sections[1].Lists[1].Title.StringContent="Business Address";
     // get broker audit data model
     this.brokerAuditDataModel = this.brokerAuditDeclarationService.brokerAuditDataModel;

     // get questionnaire data model
         this.badQuestionnaireDataModel = this.brokerAuditDeclarationService.badQuestionnaireDataModel;
 
         this.badQuestionnaireDataModel.Sections.forEach(section => {
          section.Questions.forEach(question => {
            // find answer by QuestionID from this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers
            //if no answer, then add question with N/A answer
            if (this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID) == undefined || this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID).length == 0) {
              question.Answer = new BadAnswerModel();
              question.Answer.AnswerTypeID = 3;
            }
            else{
            //add found answer in badQuestionnaireDataModel by QuestionID 
              question.Answer = this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID)[0];
              
            }
          }

          );
         });
     


        
  }


  goBackHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearHeaderContent();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearHeaderContent();

  }

  printPage(){
    window.print();
  }

  



   
  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.router.navigate(['/brokerAuditDeclarationReview']).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);

    })
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/broker-audit-declaration-receipt/broker-audit-declaration-receipt.component.ts